module.exports = __webpack_public_path__ + "img/horizontal_6_6_8011.42dc5719.png";